iScreenWizard.factory('Menu', function (userService, Dictionary) {

	var menu = {};
	menu.sections = [];

	menu.sections.push({
		name: Dictionary.translate('app.new_test_administration', true),
		type: 'link',
		state: 'nieuwe-testafname/kandidaatgegevens',
		icon: 'mi mi-add-circle',
		expert: false
	});

	menu.sections.push({
		name: Dictionary.translate('app.search_candidates', true),
		type: 'link',
		state: 'kandidaten',
		icon: 'mi mi-search',
		expert: false
	});

	menu.sections.push({
		name: Dictionary.translate('app.matching', true),
		type: 'link',
		state: 'matching',
		icon: 'mi mi-games',
		expert: true,
		moduleNr: userService.WIZARD_MODULE_MATCHING
	});

	menu.sections.push({
		name: Dictionary.translate('app.competence_profiles', true),
		type: 'link',
		state: 'competentieprofielen',
		icon: 'wizard-icon icon-profile',
		expert: false
	});

	menu.sections.push({
		name: Dictionary.translate('app.group_profile', true),
		type: 'link',
		state: 'groepsprofiel/selecteer-groepsprofieloptie',
		icon: 'wizard-icon icon-group',
		expert: true,
		moduleNr: userService.WIZARD_MODULE_GROEPSPROFIELEN
	});

	menu.sections.push({
		name: Dictionary.translate('app.360_feedback', true),
		type: 'link',
		state: '360-feedback/selecteer-feedback-rapporttype',
		icon: 'wizard-icon icon-360',
		expert: true,
		moduleNr: userService.WIZARD_MODULE_360_FEEDBACK
	});

	menu.sections.push({
		name: Dictionary.translate('app.info', true),
		type: 'toggle',
		icon: 'mi mi-info',
		open: false,
		expert: false,
		pages: [
			{
				name: Dictionary.translate('app.training_and_certification', true),
				type: 'link',
				state: 'info/trainingen-en-certificering',
				icon: ''
			},
			{
				name: Dictionary.translate('app.development_guide', true),
				state: 'info/ontwikkelwijzer',
				type: 'link',
				icon: ''
			},
			{
				name: Dictionary.translate('app.manuals', true),
				state: 'info/handleidingen',
				type: 'link',
				icon: ''
			},
			{
				name: Dictionary.translate('app.e_learning', true),
				state: 'info/e-learning',
				type: 'link',
				icon: ''
			},
			{
				name: Dictionary.translate('app.test_information', true),
				state: 'info/testinformatie',
				type: 'link',
				icon: ''
			},
			{
				name: Dictionary.translate('app.newsletter', true),
				state: 'info/nieuwsbrief',
				type: 'link',
				icon: ''
			},
			{
				name: Dictionary.translate('app.faq', true),
				state: 'info/faq',
				type: 'link',
				icon: ''
			},
			{
				name: Dictionary.translate('app.customer_experiences', true),
				state: 'info/klantervaringen',
				type: 'link',
				icon: ''
			}
		]
	});

	menu.sections.push({
		name: Dictionary.translate('app.my_iscreen', true),
		type: 'toggle',
		icon: 'wizard-icon icon-my-iscreen',
		open: false,
		expert: false,
		pages: [
			{
				name: Dictionary.translate('app.profile', true),
				type: 'link',
				state: 'mijn-iscreen/profiel',
				icon: ''
			},
			{
				name: Dictionary.translate('app.account_information', true),
				state: 'mijn-iscreen/accountinformatie',
				type: 'link',
				icon: ''
			},
			{
				name: Dictionary.translate('app.inbox', true),
				state: 'mijn-iscreen/inbox',
				type: 'link',
				icon: ''
			},
			{
				name: Dictionary.translate('app.email_log', true),
				state: 'mijn-iscreen/emaillog',
				type: 'link',
				icon: ''
			},
			{
				name: Dictionary.translate('app.mailtemplates', true),
				state: 'mijn-iscreen/mailtemplates',
				type: 'link',
				icon: ''
			},
			{
				name: Dictionary.translate('app.certificates', true),
				state: 'mijn-iscreen/certificaten',
				type: 'link',
				icon: ''
			}
		]
	});

	return menu;
});